export {
  Avatar,
  avatarClassNames,
  renderAvatar_unstable,
  useAvatarStyles_unstable,
  useAvatar_unstable,
  useAvatarBase_unstable,
} from './Avatar';
export type {
  AvatarNamedColor,
  AvatarProps,
  AvatarSlots,
  AvatarState,
  AvatarShape,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  AvatarSizes,
  AvatarSize,
  AvatarBaseProps,
  AvatarBaseSlots,
  AvatarBaseState,
} from './Avatar';
export { getInitials, partitionAvatarGroupItems } from './utils/index';
export type { PartitionAvatarGroupItems, PartitionAvatarGroupItemsOptions } from './utils/index';
export {
  AvatarGroup,
  avatarGroupClassNames,
  renderAvatarGroup_unstable,
  useAvatarGroupContextValues,
  useAvatarGroupStyles_unstable,
  useAvatarGroup_unstable,
  useAvatarGroupBase_unstable,
} from './AvatarGroup';
export type {
  AvatarGroupProps,
  AvatarGroupSlots,
  AvatarGroupState,
  AvatarGroupContextValue,
  AvatarGroupContextValues,
  AvatarGroupBaseProps,
  AvatarGroupBaseState,
} from './AvatarGroup';
export {
  AvatarGroupItem,
  avatarGroupItemClassNames,
  renderAvatarGroupItem_unstable,
  useAvatarGroupItemStyles_unstable,
  useAvatarGroupItem_unstable,
  useAvatarGroupItemBase_unstable,
} from './AvatarGroupItem';
export type {
  AvatarGroupItemProps,
  AvatarGroupItemSlots,
  AvatarGroupItemState,
  AvatarGroupItemBaseProps,
  AvatarGroupItemBaseState,
} from './AvatarGroupItem';
export {
  AvatarGroupPopover,
  avatarGroupPopoverClassNames,
  renderAvatarGroupPopover_unstable,
  useAvatarGroupPopover_unstable,
  useAvatarGroupPopoverContextValues_unstable,
  useAvatarGroupPopoverStyles_unstable,
  useAvatarGroupPopoverBase_unstable,
} from './AvatarGroupPopover';
export type {
  AvatarGroupPopoverProps,
  AvatarGroupPopoverSlots,
  AvatarGroupPopoverState,
  AvatarGroupPopoverBaseProps,
  AvatarGroupPopoverBaseState,
} from './AvatarGroupPopover';
export {
  AvatarContextProvider,
  AvatarGroupProvider,
  useAvatarContext,
  useAvatarGroupContext_unstable,
} from './contexts/index';
export type { AvatarContextValue } from './contexts/index';
